var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideVariantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.3341 22H7.66512C4.26149 22 2.00012 19.5707 2.00012 16.084V7.916C2.00012 4.43296 4.26822 2 7.66512 2H16.3341C19.7379 2 22.0001 4.4295 22.0001 7.916V16.084C22.0001 19.5705 19.7379 22 16.3341 22ZM7.66512 20.5H16.3341C18.8846 20.5 20.5001 18.765 20.5001 16.084V7.916C20.5001 5.23496 18.8846 3.5 16.3341 3.5H7.66512C5.12108 3.5 3.50012 5.23878 3.50012 7.916V16.084C3.50012 18.7653 5.11488 20.5 7.66512 20.5Z",
    fill: "#0014cb",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2212 12.2673C15.9544 12.533 15.5376 12.5563 15.2445 12.3378L15.1605 12.265L12.222 9.31354L9.28149 12.265C9.0158 12.5319 8.59919 12.557 8.30511 12.3397L8.22083 12.2673C7.95399 12.0016 7.92889 11.585 8.14611 11.2909L8.21854 11.2067L11.6895 7.72065C11.956 7.453 12.3742 7.42867 12.6683 7.64766L12.7525 7.72065L16.2235 11.2067C16.5157 11.5002 16.5147 11.9751 16.2212 12.2673Z",
    fill: "#0014cb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2212 16.2673C15.9544 16.533 15.5376 16.5563 15.2445 16.3378L15.1605 16.265L12.222 13.3135L9.28149 16.265C9.0158 16.5319 8.59919 16.557 8.30511 16.3397L8.22083 16.2673C7.95399 16.0016 7.92889 15.585 8.14611 15.2909L8.21854 15.2067L11.6895 11.7207C11.956 11.453 12.3742 11.4287 12.6683 11.6477L12.7525 11.7207L16.2235 15.2067C16.5157 15.5002 16.5147 15.9751 16.2212 16.2673Z",
    fill: "#0014cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideVariantIcon);
export default __webpack_public_path__ + "static/media/hide_variant_icon.8bc838fa3497f829591a272077b4e449.svg";
export { ForwardRef as ReactComponent };